module.exports = __webpack_public_path__ + "img/seaslogo.cfc08cba.png";